module.exports = __webpack_public_path__ + "static/media/addressBlue.8ff54689.svg";